import {
  createFileRoute,
  redirect,
  SearchParamError,
} from "@tanstack/react-router";
import { z } from "zod";

import { CancelSessionScreen } from "@/modules/coaching/cancel-sessions/screens/CancelSessionScreen";
import { cancelSessionLoader } from "@/modules/coaching/cancel-sessions/utils/cancelSessionLoader";

const cancelSessionRouteValidator = z.object({
  rescheduleUuid: z.string(),
});

export const Route = createFileRoute("/$sessionCode/cancel/$cancelUuid/")({
  validateSearch: cancelSessionRouteValidator,
  onError: (error) => {
    if (error instanceof SearchParamError) {
      throw redirect({ to: "/not-found" });
    }
  },
  loaderDeps: ({ search: { rescheduleUuid } }) => ({ rescheduleUuid }),
  loader: cancelSessionLoader,
  component: CancelSessionScreen,
});
